import { render, staticRenderFns } from "./MathMaster.vue?vue&type=template&id=959dc900&"
import script from "./MathMaster.vue?vue&type=script&lang=js&"
export * from "./MathMaster.vue?vue&type=script&lang=js&"
import style0 from "./MathMaster.vue?vue&type=style&index=0&id=959dc900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports